import { makeStyles, Theme } from '@material-ui/core/styles'

export const useStyles = makeStyles<Theme>((theme) => ({
  contentWrapper: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column'
  },
    container: {
    width: '100%',
    maxWidth: '800px',
    margin: '0 auto',

    [theme.breakpoints.down('sm')]: {
      padding: '16px 0 80px'
    }
  },
  promoImg: {
    width: '100%',
    borderRadius: 16,
    marginTop: 16,
    display: 'block'
  },
  tableContainer: {
    width: '100%',
    maxWidth: 800,
    margin: '0 auto'
  },
  paragraph: {
    marginTop: 10,
    marginBottom: theme.spacing(2),
    fontSize: '1rem',
    lineHeight: 1.7,
    color: theme.palette.text.primary
  },
  tableSubtitle: {
    textAlign: 'center',
    marginBottom: theme.spacing(2)
  },
  separator: {
    width: '100%',
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(4)
  }
}))
